import { HotelBedData } from '../shared/index';
import { isNull } from '../utils/index';
 
import { momentWrapper } from './campursari';
 
export function getStringFilter(data: string) { 
    let sessionFilter = JSON.parse(data);
    let defFilter: HotelBedData.SearchFilter = {};
    if (!isNull(sessionFilter)) {
        defFilter = sessionFilter;
        defFilter.stay!.checkIn = momentWrapper(sessionFilter.stay.checkIn);
        defFilter.stay!.checkOut = momentWrapper(sessionFilter.stay.checkOut);
        return defFilter;
    } else {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/utils/get-season-storage-filter.ts